import React from 'react';
import MockupShell from './MockupShell';

const ACTIVITY = [
  { t: '12m ago', text: 'James R. joined through your referral link.', tag: 'referral' },
  { t: '47m ago', text: 'You completed Training Module 3 of 8.', tag: 'training' },
  { t: '2h ago',  text: 'Personal PIF queue: 1 prospect about to release to network.', tag: 'queue', urgent: true },
  { t: '4h ago',  text: '+10 Lead Credits granted (tier upgrade bonus).', tag: 'credits' },
  { t: '1d ago',  text: 'Admin announcement: Phase 2 unlock criteria updated.', tag: 'announce' },
];

const ANNOUNCEMENTS = [
  { title: 'Phase 1 launch window opens this week', body: 'Builders with completed activation briefings will receive their personal PIF queue first.' },
  { title: 'New training module available',          body: 'How to share your referral link without sounding salesy. 7 minutes.' },
];

export default function MemberDashboard() {
  return (
    <MockupShell
      title="Welcome back, Builder."
      subtitle="Your back-office snapshot. Non-custodial — no money held by the platform."
      dataTestId="mockup-dashboard"
    >
      {/* Top stat row */}
      <div className="mk-grid mk-grid--4" style={{ marginBottom: 18 }}>
        <div className="mk-card">
          <div className="mk-stat">
            <span className="mk-stat-label">Tier</span>
            <span className="mk-stat-value" style={{ color: 'var(--mk-gold)' }}>ROOKIE</span>
            <span className="mk-stat-sub">Next: PRO at 5 Pay-It-Forwards given</span>
          </div>
        </div>
        <div className="mk-card">
          <div className="mk-stat">
            <span className="mk-stat-label">Direct Referrals</span>
            <span className="mk-stat-value">12</span>
            <span className="mk-stat-sub">+3 this week</span>
          </div>
        </div>
        <div className="mk-card">
          <div className="mk-stat">
            <span className="mk-stat-label">Personal PIF Queue</span>
            <span className="mk-stat-value">4</span>
            <span className="mk-stat-sub" style={{ color: 'var(--mk-amber)' }}>1 expires in 17 min</span>
          </div>
        </div>
        <div className="mk-card">
          <div className="mk-stat">
            <span className="mk-stat-label">Lead Credits</span>
            <span className="mk-stat-value">85</span>
            <span className="mk-stat-sub">Used 15 / Earned 100</span>
          </div>
        </div>
      </div>

      {/* Main grid */}
      <div className="mk-grid mk-grid--2">
        {/* Referral link */}
        <div className="mk-card">
          <h3 style={{ marginBottom: 10 }}>Your referral link</h3>
          <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
            <code style={{ flex: 1, minWidth: 180, padding: '10px 12px', background: 'var(--mk-navy-deep)', border: '1px solid var(--mk-border-2)', borderRadius: 8, fontSize: 12, color: 'var(--mk-gold)', overflowX: 'auto' }}>
              bbcquicklist.com/waitlist/BLDR4827
            </code>
            <button className="mk-btn" data-testid="copy-referral-btn">Copy</button>
          </div>
          <p style={{ margin: '10px 0 0', fontSize: 12, color: 'var(--mk-muted)' }}>
            12 direct sign-ups · 3 in Personal queue · 2 promoted to Network queue
          </p>
        </div>

        {/* Next action */}
        <div className="mk-card" style={{ borderColor: 'rgba(245, 197, 66, 0.5)' }}>
          <span className="mk-badge mk-badge--amber">Next action</span>
          <h3 style={{ margin: '10px 0 6px' }}>Pay it forward to Sarah K.</h3>
          <p style={{ margin: 0, fontSize: 13, color: 'var(--mk-muted)' }}>
            She has been in your Personal queue for 43 minutes. Pay-It-Forward: <strong style={{ color: 'var(--mk-text)' }}>5.95 USDT (TRC-20)</strong> via NowPayments.
            Member-to-member only — admin never touches this payment.
          </p>
          <div style={{ marginTop: 12, display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            <button className="mk-btn" data-testid="pif-pay-btn">Pay 5.95 USDT</button>
            <button className="mk-btn mk-btn--ghost">Release to network</button>
          </div>
        </div>

        {/* Tool widgets */}
        <div className="mk-card">
          <h3 style={{ marginBottom: 12 }}>My tools</h3>
          <div className="mk-pill-row">
            <span className="mk-badge mk-badge--gold">Link File · 14 links</span>
            <span className="mk-badge mk-badge--gold">Rotator · 2 active</span>
            <span className="mk-badge mk-badge--gold">Lead Capture · 3 published</span>
            <span className="mk-badge mk-badge--muted">QR Generator</span>
            <span className="mk-badge mk-badge--muted">Page Builder</span>
            <span className="mk-badge mk-badge--muted">Game Dashboard · locked</span>
          </div>
        </div>

        {/* Training progress */}
        <div className="mk-card">
          <h3 style={{ marginBottom: 6 }}>Training progress</h3>
          <p style={{ margin: '0 0 10px', fontSize: 13, color: 'var(--mk-muted)' }}>3 of 8 modules complete · 37%</p>
          <div className="mk-progress"><div className="mk-progress-fill" style={{ width: '37%' }} /></div>
          <button className="mk-btn mk-btn--gold-outline" style={{ marginTop: 12 }} data-testid="resume-training-btn">Resume Module 4</button>
        </div>
      </div>

      {/* Activity + Announcements */}
      <div className="mk-grid mk-grid--2" style={{ marginTop: 18 }}>
        <div className="mk-card">
          <h3 style={{ marginBottom: 10 }}>Recent activity</h3>
          <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
            {ACTIVITY.map((a, i) => (
              <li key={i} style={{ display: 'flex', gap: 12, padding: '8px 0', borderBottom: i < ACTIVITY.length - 1 ? '1px solid var(--mk-border)' : 'none' }}>
                <span style={{ fontSize: 11, color: 'var(--mk-dim)', width: 70, flexShrink: 0 }}>{a.t}</span>
                <span style={{ fontSize: 13, color: a.urgent ? 'var(--mk-amber)' : 'var(--mk-text)', lineHeight: 1.5 }}>{a.text}</span>
              </li>
            ))}
          </ul>
        </div>
        <div className="mk-card">
          <h3 style={{ marginBottom: 10 }}>Admin announcements</h3>
          {ANNOUNCEMENTS.map((a, i) => (
            <div key={i} style={{ paddingBottom: 10, marginBottom: 10, borderBottom: i < ANNOUNCEMENTS.length - 1 ? '1px solid var(--mk-border)' : 'none' }}>
              <strong style={{ fontSize: 13 }}>{a.title}</strong>
              <p style={{ margin: '4px 0 0', fontSize: 12, color: 'var(--mk-muted)', lineHeight: 1.5 }}>{a.body}</p>
            </div>
          ))}
        </div>
      </div>
    </MockupShell>
  );
}
